import styled from "styled-components";
import { position, PositionProps } from "styled-system";

export const StyledDotsContainer = styled.ul<PositionProps>`
	list-style: none;
	display: inline-flex;
	margin: 0;
	padding: 0;
	${position}

	${({ theme }) => ({
		height: theme.space.md,
		gap: theme.space.md,
	})}
`;

export const StyledButton = styled.button`
	margin: 0;
	padding: 0;
	height: 100%;
	border: none;
	cursor: pointer;
	background-color: grey;
	transition: width 300ms ease-out;
	display: block;
	${({ theme }) => ({
		width: theme.space.md,
		borderRadius: theme.radii.md,
		backgroundColor: theme.palette.hexForRole("fg_light_2"),

		"&:hover": {
			backgroundColor: theme.palette.hexForRole("fg_light_3"),
		},
	})}
`;

export const StyledDot = styled.li`
	${({ theme }) => ({
		"&.PaginationDots__dot--active > .PaginationDots__button": {
			backgroundColor: theme.palette.hexForRole("cta_default"),
			width: theme.space.xl,
		},
	})}
`;
